// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__DBiu5","label":"styles_label__3aNgm","disable":"styles_disable__3rStt"};